import { Link } from 'react-router-dom';

export default function KnowledgeCta() {
  return (
    <section id="knowledge-cta" className="bg-[#5C5470] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left */}
          <div className="text-center lg:text-left max-w-xl">
            <p className="text-[#D4A373] font-semibold tracking-widest mb-4" style={{ fontSize: '1rem' }}>
              NEXT STEP
            </p>
            <h2
              className="font-serif font-bold text-white mb-5"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
            >
              看完文章，還是不確定
              <br />
              自己適合什麼？
            </h2>
            <p className="text-white/75" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
              每個人的保障答案都不同。與其自己猜，不如先做一次保單健檢，讓琮恩幫您找出真正需要的保障結構。
            </p>
          </div>

          {/* Right: Buttons */}
          <div className="flex flex-col gap-4 flex-shrink-0 w-full lg:w-auto">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-calendar-check-line"></i>
              預約一對一諮詢
            </Link>
            <Link
              to="/about#health-check-form"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/40 text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:border-white hover:bg-white/10 transition-all duration-200"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-download-line"></i>
              下載保單健檢表
            </Link>
          </div>
        </div>

        {/* Bottom trust row */}
        <div className="mt-16 pt-12 border-t border-white/15 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: 'ri-article-line', text: '持續更新保險知識' },
            { icon: 'ri-shield-check-line', text: '內容由持照顧問撰寫' },
            { icon: 'ri-chat-smile-3-line', text: '用白話文說清楚' },
            { icon: 'ri-heart-line', text: '以客戶利益為出發點' },
          ].map((b) => (
            <div key={b.text} className="flex items-center gap-3 text-white/75">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className={`${b.icon} text-[#D4A373] text-xl`}></i>
              </div>
              <span style={{ fontSize: '1.0625rem' }}>{b.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
